module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }